import {Datepicker} from 'vanillajs-datepicker';
import nl from 'vanillajs-datepicker/locales/nl';

Object.assign(Datepicker.locales, nl);

export default class DatePicker {
    constructor($input) {
        this.$input = $input;

        this.syncInputState = this.syncInputState.bind(this);

        this.datepicker = new Datepicker(this.$input, {
            autohide: true,
            buttonClass: 'button',
            format: 'dd/mm/yyyy',
            language: document.documentElement.lang || 'nl',
        });

        this.$input.addEventListener('changeDate', this.syncInputState);
    }

    syncInputState() {
        this.$input.dispatchEvent(new Event('input', {bubbles: true}));
    }
}
